import * as React from 'react';

import classNames from 'classnames';

type Props = {
    image: React.ReactNode;
    width: number;
    noPadding?: boolean;
};

export function ImageWrapper(props: Props) {
    const {noPadding = false} = props;

    const wrapperClassName = classNames(
        'full-width full-height border-box align-center justify-center flex',
        {
            'pad-64': !noPadding,
        }
    );

    return (
        <div className={wrapperClassName}>
            <div style={{width: `${props.width}px`}}>{props.image}</div>
        </div>
    );
}
